module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_maternity@3x-4fa5782559c447075aeb258ab60fb9ad.webp";